import { render, staticRenderFns } from "./SetupOrg.vue?vue&type=template&id=14f40749&"
import script from "./SetupOrg.vue?vue&type=script&lang=js&"
export * from "./SetupOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports